var uploadData = {
  name: 'upload',
  data: [{
    fontSize: 14
  }]
};
export default uploadData;